
<mat-dialog-content class="dark">

  <mat-form-field class="w-full" floatLabel="always">
    <mat-label>Did they opt in?</mat-label>
    <mat-select [(ngModel)]="decision" required>
      <mat-select-trigger>
        <span *ngIf="decision == 'OPT_IN'" class="text-positive">
          <fa-icon icon="thumbs-up"></fa-icon> Yes
        </span>
        <span *ngIf="decision == 'OPT_OUT'" class="text-negative">
          <fa-icon icon="thumbs-down"></fa-icon> No
        </span>
      </mat-select-trigger>
      <mat-option value="OPT_IN">
        <span class="text-positive">
          <fa-icon icon="thumbs-up"></fa-icon> Yes
        </span>
      </mat-option>
      <mat-option value="OPT_OUT">
        <span class="text-negative">
          <fa-icon icon="thumbs-down"></fa-icon> No
        </span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="w-full" *ngIf="decision == 'OPT_IN'" floatLabel="always">
    <mat-label>What feedback did they receive?</mat-label>
    <mat-select [(ngModel)]="assessment">
      <mat-select-trigger>
        <span *ngIf="assessment == 'NONE'">
          <fa-icon icon="circle-minus"></fa-icon> None (not chosen)
        </span>
        <span *ngIf="assessment == 'GOOD'" class="text-positive">
          <fa-icon icon="face-grin-stars"></fa-icon> Good
        </span>
        <span *ngIf="assessment == 'OK'" class="text-amber">
          <fa-icon icon="face-smile"></fa-icon> Ok
        </span>
        <span *ngIf="assessment == 'POOR'" class="text-negative">
          <fa-icon icon="face-meh"></fa-icon> Poor
        </span>
      </mat-select-trigger>
      <mat-option value="NONE">
        <fa-icon icon="circle-minus"></fa-icon> None (not chosen)
      </mat-option>
      <mat-option value="GOOD" >
        <span class="text-positive">
          <fa-icon icon="face-grin-stars"></fa-icon> Good
        </span>
      </mat-option>
      <mat-option value="OK" >
        <span class="text-amber">
          <fa-icon icon="face-smile"></fa-icon> Ok
        </span>
      </mat-option>
      <mat-option value="POOR" >
        <span class="text-negative">
          <fa-icon icon="face-meh"></fa-icon> Poor
        </span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="w-full" floatLabel="always">
    <mat-label>Why is this adjustment needed?</mat-label>
    <textarea matInput rows="5" [(ngModel)]="explanation" name="explanation" placeholder="Provide an explanation/justification for the student"></textarea>
  </mat-form-field>


</mat-dialog-content>

<mat-dialog-actions class="text-right">
  <button class="w-full" mat-flat-button color="primary" [disabled]="!canConfirm" (click)="confirm()">
    Make adjustment
  </button>
</mat-dialog-actions>
